import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VisorFirebaseService } from 'app/services/visor-firebase.service';

@Component({
  selector: 'ngx-equipo-aplicador',
  templateUrl: './equipo-aplicador.component.html',
  styleUrls: ['./equipo-aplicador.component.scss']
})
export class EquipoAplicadorComponent implements OnInit {

  constructor(protected visorFirebaseService: VisorFirebaseService){}

  newEquipoAplicador: any = {equipo:{},aplicador:{}};
  equipos: any[];
  aplicadores: any[];
  ngOnInit(): void {
    this.visorFirebaseService.obtenerMaquinaria().subscribe(d => {
      this.equipos = d;
    });
    this.visorFirebaseService.obtenerAsesoresAplicadores().subscribe(d => {
      this.aplicadores = d.filter(a => a.tipo.identifier == '2');
    });
  }

  @Input('equipos-aplicadores')
  equiposAplicadores: any[];

  @Output('equipos-aplicadores') valueChange = new EventEmitter<any[]>();


  calcularIdItem(item){
    return item.identifier;
  }
  calcularLabelItem(item){
      return item.nombre;
  }

  addEquipoAplicador(){
    this.equiposAplicadores.push(Object.assign({},this.newEquipoAplicador));
    this.newEquipoAplicador = {equipo:{},aplicador:{}};
    this.valueChange.emit(this.equiposAplicadores);
  }
  deleteEquipoAplicador(index){
    this.equiposAplicadores.splice(index,1);
    this.valueChange.emit(this.equiposAplicadores);
  }
}
